import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const mapSandboxToString = (sandbox = '') => {
  const sandboxDetails = { ...sandbox };

  if (typeof sandbox === 'string') {
    return sandbox;
  }

  return Object.keys(sandboxDetails)
    .filter(key => sandboxDetails[key])
    .map(s => s.replace(/[A-Z]/g, '-$&').toLowerCase())
    .join(' ');
};

class Iframe extends PureComponent {
  static propTypes = {
    // The width attribute specifies the width of an iframe, in pixels.
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    // The height attribute specifies the height of an iframe, in pixels.
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    // The sandbox attribute enables an extra set of restrictions for the content in the iframe.
    sandbox: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        // Re-enables form submission
        allowForms: PropTypes.bool,

        // Sandboxed frames will block modal dialogs by default
        allowModals: PropTypes.bool,

        // Re-enables APIs
        allowPointerLock: PropTypes.bool,

        // Re-enables popups
        allowPopups: PropTypes.bool,

        // Allows the iframe content to be treated as being from the same origin
        allowSameOrigin: PropTypes.bool,

        // Re-enables scripts
        allowScripts: PropTypes.bool,

        // Allows the iframe content to navigate its top-level browsing context
        allowTopNavigation: PropTypes.bool,
      }),
    ]),
    src: PropTypes.string.isRequired,

    // Callback invoked when the iframe has been loaded:
    onLoad: PropTypes.func,

    // Callback invoked when the iframe has unloaded: `({ event: Event }): void`
    onUnload: PropTypes.func,

    // Callback invoked when the iframe is about to be unloaded:
    // `({ event: Event, iframe: HTMLElement }): void`
    onBeforeUnload: PropTypes.func,

    //
    style: PropTypes.instanceOf(Object),

    title: PropTypes.string,
  };

  static defaultProps = {
    width: '100%',
    height: '100%',
    sandbox: {
      allowForms: true,
      allowModals: true,
      allowPointerLock: false,
      allowPopups: true,
      allowSameOrigin: true,
      allowScripts: true,
      allowTopNavigation: false,
    },
    style: {},
    onLoad: () => {},
    onBeforeUnload: () => {},
    onUnload: () => {},
    title: 'Iframe',
  };

  render() {
    const {
      style,
      onLoad, // eslint-disable-line
      onBeforeUnload, // eslint-disable-line
      onUnload, // eslint-disable-line
      title,
      src,
      ...props
    } = this.props;

    if (props.sandbox === false) {
      delete props.sandbox;
    } else if (typeof props.sandbox === 'object') {
      props.sandbox = mapSandboxToString(props.sandbox);
    }

    return (
      <iframe
        title={title}
        {...props}
        src={src}
        style={{
          borderWidth: 0,
          ...style,
        }}
        onLoad={onLoad}
      />
    );
  }
}

export default Iframe;
